// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const reImportAppPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_user_id: z.number().int().describe("AppUser id"),
});

export const reImportAppHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Re-import triggered
 */
export const reImportApp204Schema = z.unknown();

/**
 * @description AppUser not found
 */
export const reImportApp404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const reImportAppQueryResponseSchema = z.lazy(() => reImportApp204Schema);
